export enum PLUS_3_STANDARD_ATLAS_FRAMES {
  LOGO = 'logo.png',
  GLOW = 'glow.png',
  NUMBER_SYSTEM_SELECTED_TRANSITION = 'numbers/system-selected-transition.png',
  NUMBER_SYSTEM_SELECTED = 'numbers/system-selected.png',
}

export enum PLUS_3_TEXTURE_KEYS {
  STANDARD_ATLAS = 'PLUS_3_ATLAS',
  ANIMATION_ATLAS = 'PLUS_3_ATLAS_',
  NUMBER_SYSTEM_SELECTED_TRANSITION = 'PLUS_3_SYSTEM_SELECTED_TRANSITION_',
  NUMBER_SYSTEM_SELECTED = 'PLUS_3_SYSTEM_SELECTED_',
  NUMBER_HIT = 'PLUS_3_HIT_',
  NUMBER_HIT_TRANSITION = 'PLUS_3_HIT_TRANSITION_',
}

export enum PLUS_3_ANIMATION_ATLAS_FRAMES {
  NUMBER_HIT = 'player-selected.png',
  NUMBER_HIT_TRANSITION = 'player-selected-transition.png',
  NUMBER_GLOW = 'glow.png',
}
